import { primitives, Primitives } from './generated/tokens.generated';

interface IFontFamily {
  averta: string;
  euclid: string;
}

// All weights (light/regular/medium/semiBold/bold) come from the generated (Figma-derived) primitives.
type IFontWeight = Primitives['fontWeight'];

// Sourced from the generated (Figma-derived) primitives. Do not re-declare values here;
// regenerate via `yarn tokens:build`.
type IFontSize = Primitives['fontSize'];

// Raw px line-heights from the generated primitives. Get a size's paired % with `lineHeight(theme.font.size.X)`.
type ILineHeight = Primitives['lineHeight'];

export interface IFont {
  family: IFontFamily;
  weight: IFontWeight;
  size: IFontSize;
  lineHeight: ILineHeight;
}

export const Font: IFont = {
  family: {
    averta: 'Averta, serif',
    euclid: 'Euclid Circular A, sans-serif',
  },
  weight: primitives.fontWeight,
  size: primitives.fontSize,
  lineHeight: primitives.lineHeight,
};
